import type { ProcessedArtist } from '@app/data/clients/monolithClients/explore/types';
import { localizedPath } from '@app/utils/common';
import { Box, Button, Card, Image, Text } from '@redbubble/design-system';
import * as constants from '@redbubble/design-system/react/constants';
import { defineMessages, FormattedMessage } from '@redbubble/next/intl';
import type { UserInfo } from '@redbubble/next/types';
import { useUserInfo } from '@redbubble/next-provider';
import React from 'react';
import styles from './ArtistCard.module.scss';

const messages = defineMessages({
  viewShopButtonText: {
    defaultMessage: 'View Shop',
  },
});

export interface ArtistCardProps {
  artist: ProcessedArtist['artist'];
  coverImage: ProcessedArtist['cover'];
}

export const ArtistCard: React.FC<ArtistCardProps> = ({
  artist,
  coverImage,
}) => {
  const { username, avatarUrl, shopDisplayName } = artist;
  const [{ locale }] = useUserInfo<UserInfo>();
  const artistShopUrl =
    username && localizedPath(locale, `/people/${username}/shop`);

  return (
    <Card
      onClick={() => {
        window.location.assign(artistShopUrl);
      }}
    >
      <Image
        fluid
        src={coverImage}
        alt={shopDisplayName}
        className={styles.coverImage}
      />
      <div className={styles.artistCardBody}>
        <Image
          src={avatarUrl}
          alt={shopDisplayName}
          className={styles.avatarImage}
        />
        <div className={styles.artistName}>
          <Text type="display5" className={styles.artistNameText}>
            {shopDisplayName}
          </Text>
        </div>
        <Box display="flex" justifyContent="center" marginTop={1}>
          <FormattedMessage {...messages.viewShopButtonText}>
            {(text) => (
              <Button href={artistShopUrl} size={constants.MEDIUM} strong>
                {text}
              </Button>
            )}
          </FormattedMessage>
        </Box>
      </div>
    </Card>
  );
};
